<template>
    <div class="wrapper">
        <p> {{ $t("userAMLQuestionnaire.startStep.labelOne") }} </p>
        <p>
            {{ $t("userAMLQuestionnaire.startStep.labelTwoPartOne") }}
            <a :href="termsAndConditionsLink"
                target="_blank"
            >{{ $t("userAMLQuestionnaire.startStep.labelTwoPartTwo") }}</a>
            {{ $t("userAMLQuestionnaire.startStep.labelTwoPartThree") }}
        </p>
        <input-checkbox
            :value="startQuestionnaireConfirmed"
            :text="`${$t('userAMLQuestionnaire.startStep.confirmMessage')}`"
            :maxWidth="false"
            isWholeAreaClickable
            noBackground
            @toggleCheckBox="handleStepConfirmation"
        />
    </div>
</template>

<script>
// 3rd party libs
import {
    mapGetters,
    mapActions,
} from 'vuex';

// Components
import inputCheckbox from '@webapp/components/inputs/input-checkbox.vue';

// Utils
import {
    getUserAgreementLink,
} from '@shared/utils/user-agreement';

export default {
    name: 'start-questionnaire',
    components: {
        inputCheckbox,
    },
    data() {
        return {
            startQuestionnaireConfirmed: false,
            termsAndConditionsLink: '',
        };
    },
    computed: {
        ...mapGetters(['localeISO2']),

        ...mapGetters('agreements', ['acceptedUserAgreement']),
    },
    watch: {
        acceptedUserAgreement() {
            this.termsAndConditionsLink = getUserAgreementLink(this.acceptedUserAgreement);
        },
    },
    mounted() {
        this.fetchAcceptedUserAgreement({
            details: ['agreementVersionTranslations'],
            locales: [this.localeISO2],
        });
    },
    methods: {
        ...mapActions('agreements', ['fetchAcceptedUserAgreement']),

        handleStepConfirmation() {
            this.startQuestionnaireConfirmed = !this.startQuestionnaireConfirmed;

            if (this.startQuestionnaireConfirmed) {
                this.$emit('completed');
            } else {
                this.$emit('in-progress');
            }
        },
        resetStep() {
            this.startQuestionnaireConfirmed = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    font-size: 1.65rem;
    line-height: 20px;

    a {
        text-decoration: none;
        color: $lima-color;
    }

    ::v-deep {
        .checkbox {
            padding-left: 0;

            .checkbox-label {
                font-size: 1.65rem;
                font-weight: bold;
            }
        }
    }
}
</style>